export default __webpack_public_path__ + "static/media/Advant-1.f66c8fe3.png";